var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "login-container" }, [
    _c("div", { staticClass: "login-form" }, [
      _c("div", { staticClass: "content flex items-center justify-between" }, [
        _c(
          "div",
          { staticClass: "form-l" },
          [
            _vm._m(0),
            _vm._m(1),
            _c("login-method-switch", {
              attrs: { current: _vm.current },
              on: { click: _vm.handleLoginMethodSwitch },
            }),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "form-r" },
          [
            _c("login-form", {
              attrs: { type: _vm.formType },
              on: {
                "update:type": function ($event) {
                  _vm.formType = $event
                },
              },
            }),
          ],
          1
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "title" }, [
      _c("div", [_vm._v("云南省高校")]),
      _c("div", [_vm._v("人才市场")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "form-l-shading" }, [
      _c("img", {
        staticStyle: { width: "100%" },
        attrs: {
          src: require("@/assets/images/login/bg-pattern.png"),
          alt: "",
        },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }